import React from 'react';

import { BasicSelector, BasicSelectorProps } from './basic-selector';

type ZoneCategoryTargetIntervalSelectorProps = BasicSelectorProps;

export const ZoneCategoryTargetIntervalSelector = ({ ...rest }: ZoneCategoryTargetIntervalSelectorProps) => {
  const label = 'Target Interval';

  const _options = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'annually', label: 'Annually' },
  ];

  const options = _options.map((item) => item.value);
  const getOptionLabel = React.useCallback(
    (option: any) => _options.find((item) => item.value === option)?.label || '',
    [options],
  );

  const componentProps: Partial<ZoneCategoryTargetIntervalSelectorProps> = {
    label,
    options,
    getOptionLabel,
    optionsConfig: false,
  };

  return <BasicSelector {...componentProps} {...rest} />;
};
